module.exports = window["canvas"];